import React, { useMemo, useState } from 'react';
import ModuleContext from 'CMFW/context/ModuleContext';
import ItemLayout from 'CMFW/layout/ItemLayout';
import { useForceRender } from 'hooks/useForceRender';
import { TranslationBankModel } from 'models/TranslationBankModel';
import Grid from 'CMFW/grid/Grid';
import { Split } from 'components/Split';
import ReloadButton from 'CMFW/button/ReloadButton';
import { Button } from '@material-ui/core';
import { ContainerLeft, ContainerLeftFooter, ContainerRight, ModuleContainer } from 'components/common/styles';
import { LoadingItem } from 'CMFW/layout/Loading';
import BankCreate from '../components/TranslationBank/BankCreate';
import BankItemsPanel from './TranslationBank/BankItemsPanel';

interface IProps {
  isPreset?: boolean;
}

const TranslationBank: React.FC<IProps> = ({ isPreset = false }) => {
  const forceRender = useForceRender();
  const [showCreate, setShowCreate] = useState(false);

  const model = useMemo(
    () => new TranslationBankModel({ render: forceRender, isPreset }),
    [forceRender, isPreset],
  );

  const handleNewClick = () => setShowCreate(true);
  const handleCreateClose = () => setShowCreate(false);

  const handleCreateSuccess = async (bankId: number) => {
    setShowCreate(false);
    await model.loadItemEdit(bankId);
  };

  return (
    <ModuleContainer>
      <ModuleContext.Provider value={model}>
        <Split widthLeft={232}>
          <ContainerLeft>
            <Grid />
            <ContainerLeftFooter>
              <ReloadButton />
              {!isPreset && (
                <Button variant="outlined" onClick={handleNewClick} size="small">
                  new
                </Button>
              )}
            </ContainerLeftFooter>
          </ContainerLeft>

          <ContainerRight>
            <ItemLayout>
              <BankItemsPanel />
            </ItemLayout>
            <LoadingItem />
          </ContainerRight>
        </Split>
      </ModuleContext.Provider>

      {showCreate && <BankCreate model={model} onClose={handleCreateClose} onSuccess={handleCreateSuccess} />}
    </ModuleContainer>
  );
};

export default TranslationBank;
